/*
* Declaration of the global namespace sptk
*  with 3 defaults namespace : utils, modules, plugins, libs
*/
const sptk = {
    utils : {},
    modules : {},
    //plugins : {},
    libs : {}
};

/*--------------------------------------------------------------
* Namespace utils
--------------------------------------------------------------*/
const sptkModule = ((sptk) => {

    "use strict";

    let utils = sptk.utils || (sptk['utils'] = {}),
        $body = document.body;

    /*
    * sptk.utils.isMobileTablet
    * @return {bsptklean}
    */
    utils.isMobileTablet = (
        navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/windows phone/i) ||
        navigator.userAgent.match(/BlackBerry/i)
    ) ? true : false;

    utils.isMobile = (
        (navigator.userAgent.match(/Android/i) && navigator.userAgent.indexOf('Mobile') > -1) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/windows phone/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/BB10/i)
    ) ? true : false;

    utils.isTablet = (
        (navigator.userAgent.match(/Android/i) && navigator.userAgent.indexOf('Mobile') == -1) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPad/i)
    ) ? true : false;

    return sptk;

})(sptk || {});


//Export sptk
export default sptk;
